import { CLOUD, clothesPhoto, roulettePhoto, vehiclePhoto, itemPhoto } from "./photofn.js";
import { ANIM_CATS, animPhoto } from "./anims.js";
const JC_COIN = CLOUD + "jc.png";
const LT_TOKEN = roulettePhoto("items_5");
const BADGE = ["items_13", "items_14", "items_15", "items_16"].map(roulettePhoto);
const RAR = {
  common: 1,
  uncommon: 2,
  rare: 2,
  epic: 3,
  legendary: 4,
  mythic: 4,
  event: 3
};
const POOL = {
  mask: [5, 12, 26, 41].map((d) => clothesPhoto(-1, d, 0, true)),
  top: [21, 5, 8, 70, 90].map((d) => clothesPhoto(-11, d, 0, true)),
  hat: [5, 17, 26, 55].map((d) => clothesPhoto(-12, d, 0, true)),
  watch: [8, 17].map((d) => clothesPhoto(-14, d, 0, true)),
  bag: [1, 90].map((d) => clothesPhoto(-5, d, 0, true)),
  car: ["t20", "zentorno", "krieger", "sultan3", "elegy2"].map(vehiclePhoto)
};
const EMOTES = (ANIM_CATS.find((c) => c.id === "dances")?.items ?? []).slice(0, 24).map(animPhoto);
function pick(list, seed) {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = h * 31 + seed.charCodeAt(i) >>> 0;
  return list[h % list.length];
}
function cosmeticArt(id) {
  const s = String(id || "");
  if (s.startsWith("mask_")) return [pick(POOL.mask, s), POOL.mask[0]];
  if (s.startsWith("emote_")) return EMOTES.length ? [pick(EMOTES, s)] : [pick(POOL.top, s)];
  if (s.startsWith("top_") || s.startsWith("set_")) return [pick(POOL.top, s)];
  if (s.startsWith("watch")) return [pick(POOL.watch, s)];
  if (s.startsWith("wrap_")) return [itemPhoto(107)];
  if (s.startsWith("neon_") || s.startsWith("paint_") || s.startsWith("livery_")) return [pick(POOL.car, s)];
  if (s.startsWith("title_") || s.startsWith("profile_") || s.startsWith("nameplate_") || s.startsWith("badge_")) {
    return [pick(BADGE, s)];
  }
  if (s.startsWith("decor_") || s.startsWith("furniture") || s.startsWith("interior")) return [itemPhoto(40)];
  const all = [...POOL.top, ...POOL.mask, ...POOL.hat, ...POOL.watch, ...POOL.bag];
  return [pick(all, s)];
}
const cleanLabel = (s) => String(s || "").replace(/\s*·\s*ур\.\s*\d+\s*$/i, "").trim();
function tierArt(tier, track) {
  const kind = track === "free" ? tier.free : tier.premium;
  const rawLabel = track === "free" ? tier.freeLabel : tier.premiumLabel;
  if (!kind) return null;
  const rarity = RAR[tier.rarity] ?? 1;
  const label = cleanLabel(rawLabel) || "\u041D\u0430\u0433\u0440\u0430\u0434\u0430";
  if (kind.kind === "currency") {
    const cur = kind.currency;
    return {
      img: [cur === "JC" ? JC_COIN : LT_TOKEN],
      label: cur === "JC" ? `${kind.amount} JC` : `\u0416\u0435\u0442\u043E\u043D\u044B \xD7${kind.amount}`,
      note: cur === "JC" ? "\u0432\u0430\u043B\u044E\u0442\u0430" : "\u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
      rarity: cur === "JC" ? 3 : 2
    };
  }
  if (kind.kind === "qol") {
    return { img: [pick(BADGE, kind.unlock)], label, note: "\u0443\u0434\u043E\u0431\u0441\u0442\u0432\u043E", rarity };
  }
  return { img: cosmeticArt(kind.cosmeticId), label, note: "\u043A\u043E\u0441\u043C\u0435\u0442\u0438\u043A\u0430", rarity };
}
export {
  JC_COIN,
  tierArt
};
